const played = new Set();

export const prefersReducedMotion = () => {
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return false;
  }
};

export const shouldPlayIntro = (name, key) => {
  if (key === null || key === undefined || key === "" || prefersReducedMotion()) return false;
  const id = `${name}:${key}`;
  if (played.has(id)) return false;
  played.add(id);
  return true;
};
